(function () {
    "use strict";

    angular.module("app").factory("assistanceInService", assistanceInServiceFactory);

    assistanceInServiceFactory.$inject = ["$rootScope", "codesService", "apiClientFactory",];
    function assistanceInServiceFactory($rootScope, codesService, apiClientFactory) {
        const store = {
            foreignPartners: []
        };

        loadForeignPartners();

        return {
            addForeignPartnerInfo,
            confirmResults,
            assistanceInResultCodes: getPossibleResults(),
        };

        function loadForeignPartners() {
            codesService.getCodePartnersList(handlePartners);

            function handlePartners(list) {
                for (const partnerObject of list) {
                    if (partnerObject.Key === "BE")
                        continue;

                    store.foreignPartners.push(...partnerObject.Value.map(p => ({ ...p, CountryCode: partnerObject.Key })));
                }
            }
        }

        function addForeignPartnerInfo(request) {
            request.Partner = store.foreignPartners.find(p => p.Key === request.PartnerCode);
        }

        function confirmResults(items /* Guid[] */, successCallback, errorCallback, finallyCallback) {
            const api = apiClientFactory.post("AssistanceIn/CompletedRequests");

            api(
                items.map(id => ({ PublicId: id })),
                successCallback,
                errorCallback,
                finallyCallback
            );
        }

        function getPossibleResults() {
            const allScreeningResultCodes = $rootScope.codeScreeningResults.map(code => ({ Key: Number.parseInt(code.Key), Value: code.Value }));

            allScreeningResultCodes.find(item => item.Key === 12).Value = allScreeningResultCodes.find(item => item.Key === 10).Value;

            return allScreeningResultCodes.filter(result => [12, 30, 31].includes(result.Key));
        }
    }
})();
